import type { AccessMode } from './services/user'

export type RouteTableKind = 'next' | 'dialer'

// Dialer-only trumps ui_mode: the dialer table IS the access allowlist, so a
// stale localStorage ui_mode must never route such a user into another table.
export function selectRouteTable(accessMode: AccessMode): RouteTableKind {
  return accessMode === 'dialer_only' ? 'dialer' : 'next'
}

// Which access mode the router was built for. CallbackPage compares the
// post-login identity against this to decide SPA-push vs full reload.
let builtAccessMode: AccessMode = 'full'

export function setBuiltAccessMode(mode: AccessMode): void {
  builtAccessMode = mode
}

export function getBuiltAccessMode(): AccessMode {
  return builtAccessMode
}
